import Axios from "axios";
import { Notification, Loading } from "element-ui";
import Config from "@/config/index.js";
import { getToken, removeToken } from "@/utils/common.js";

let LoadingInstance = null;

const service = Axios.create({
  baseURL: Config.apiUrl + Config.apiPrefix,
  headers: {
    Accept: "*/*"
  },
  timeout: Config.timeout
});

service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
  config => {
    if (!config.closeLoading) {
      //加载提示
      LoadingInstance = Loading.service({ fullscreen: true });
    }
    config.headers["businessSource"] = 1;
    config.headers["terminalPlatform"] = 4;
    config.headers["accessMode"] = 1;
    config.headers["requestId"] = new Date().getTime();
    config.headers["Authorization"] = getToken() || "";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    if (LoadingInstance) {
      setTimeout(() => {
        LoadingInstance.close();
      }, 320);
    }
    if (res.status !== 200) {
      Notification.error({
        title: "错误",
        message: "数据返回出错"
      });
      return Promise.reject("响应非200！");
    } else {
      if (res.data.code == 100004) {
        Notification.error({
          title: "错误",
          message: "登录状态失效，请重新登陆"
        });
        setTimeout(() => {
          removeToken();
          window.location.href = "./loginIndex.html";
        }, 1000);
        return Promise.reject("error");
      }
      if (res.data.code != 100000) {
        if (res.config.closeInterceptors) {
          return Promise.reject(res.data); //自己处理错误
        }
        //统一处理错误
        Notification.error({
          title: "错误",
          message: res.data.msg
        });
        return Promise.reject("error");
      }
      return res.data.data;
    }
  },
  error => {
    if (LoadingInstance) {
      LoadingInstance.close();
    }
    //Toast("网络错误");
    Notification.error({
      title: "错误",
      message: "服务器出错"
    });
    return Promise.reject(error);
  }
);

export default service;
